
export const PhotoGuidePopup = ({isVisible =true, onClose=f=>f})=>{

    if(!isVisible)return null;
    return (
        <div className="guidePopup" onClick={onClose} >
        <div className="container">
            <h3 className="title">&lt;  독서화  약속 &gt;</h3>
            <div className="subTitle">▶ 독서화가가 되는 법: </div>
            <p>
                - 배경, 그림 이미지, 글자 를 이용해, 기억에 남는 장면이나 느낀 점, 편지 등 해당 책과 관련된 내용을 표현해 보아요.
            </p>

            <div className="subTitle">▶ 이런 독서화는 삭제가 됩니다.</div>
            <p>
                - 배경만 올린 경우, 그림 스티커를 5개 이하로 넣은 경우, 글자만 몇 글자 있는 경우<br />
                - 다른 책의 독서화를  올렸다 판단되는 경우
            </p>

            <div className="subTitle">▶ 사용방법.</div>
            <p>
                - 첫째(배경) : 표현하려고 하는 것이 어울릴 만한 배경을 찾아 선택해 주세요<br />
                - 둘째(그림) : 표현하려는 그림을 찾거나 검색해서 선택해 주세요.<br />
                - 셋째(글자) : 글자를 추가하여 조금 더 재미있고 자세하게 만들어 완성해 보세요.
            </p>
        </div>
    </div>
    );
}